import { render, staticRenderFns } from "./batch-order.vue?vue&type=template&id=6f1c87d2&scoped=true&"
import script from "./batch-order.vue?vue&type=script&lang=js&"
export * from "./batch-order.vue?vue&type=script&lang=js&"
import style0 from "./batch-order.vue?vue&type=style&index=0&id=6f1c87d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f1c87d2",
  null
  
)

export default component.exports